import { Alert, Text } from '@mantine/core';
import { ApiError } from '../../hooks';

interface LoadErrorProps {
  failedItem: string;
  error: ApiError;
}

export const LoadError = ({ failedItem, error }: LoadErrorProps) => {
  return (
    <Alert color="red" variant="light">
      <Text fw={700} mb="xs">
        Error loading {failedItem}
      </Text>
      <Text size="sm">{error?.message}</Text>
    </Alert>
  );
};
